import React from 'react';

export const RadioBox = props => (
  <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 .5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21ZM11 20a9 9 0 1 1 0-17.999A9 9 0 0 1 11 20Z"
      fill="#224251"
    />
  </svg>
);
